import {postJson, get, downloadAttachment} from "@/utils/http";
import {SYS_APi_SCREENING_URL} from '@/utils/globals'

// 当前渠道查询
export const currentChannel = p => get(SYS_APi_SCREENING_URL + "/newChannel/currentChannel", p);

// 渠道资质文件查询
export const getQualificationFiles = p => get(SYS_APi_SCREENING_URL + "/newChannel/getQualificationFiles", p);

// 渠道文件列表
export const getUploadFileList = p => postJson(SYS_APi_SCREENING_URL + "/newChannel/getUploadFileList", p);

// 渠道导出
export const expZip = p => downloadAttachment(SYS_APi_SCREENING_URL + "/newChannel/exportZip", p);

// 渠道列表分页查询
export const pageQuery = p => postJson(SYS_APi_SCREENING_URL + "/newChannel/pageQuery", p);

// 渠道下拉字典
export const channelDict = p => get(SYS_APi_SCREENING_URL + "/newChannel/channelDict", p);

// 渠道详情
export const detail = p => get(SYS_APi_SCREENING_URL + "/newChannel/detail", p);

// 渠道下流程流水列表（分页）
export const getWorkflowsByChannel = p => postJson(SYS_APi_SCREENING_URL + "/newChannel/channelWorkFlowPageQuery", p);